import React from "react";
import Card, { CardProps } from "./Card";
import { LazyMotion, domAnimation, m } from "framer-motion";

export interface HowerImageCardsProps {
  data: HoverImageCardsData;
}

interface HoverImageCardsData {
  sectionName: string;
  smallTitle: string;
  title: string;
  buttonText?: string;
  card: Array<{
    id: string;
    item: CardProps;
  }>;
  boxHeight: "full" | "small";
}

export default function HowerImageCards({ data }: HowerImageCardsProps) {
  const boxHeightClass = data.boxHeight === "full" ? "h-[80vh]" : "h-[50vh]";
  const sectionId = data.sectionName
    ? data.sectionName.replace(/\s+/g, "-")
    : "";
  let sectionClass = "";
  if (data.boxHeight === "full") {
    sectionClass = "pt-8";
  }
  const cardsCount = data.card.length;
  const lgCols =
    cardsCount === 6
      ? "desktop:grid-cols-3"
      : `desktop:grid-cols-${cardsCount}`;
  return (
    <LazyMotion features={domAnimation}>
      <div id={sectionId?.replaceAll(/[^a-zA-Z0-9-_]/g, "-")}>
        <section
        className={`flex flex-wrap justify-center items-center gap-4 ${sectionClass} bg-accent-color-three-dark`}
      >
        <div className="w-full">
          {data.title && (
            <div className="mb-8 text-center">
              <m.p
                className="text-secondary-light uppercase text-special-h2 mb-2"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
              >
                {data.smallTitle}
              </m.p>
              <m.p
                className="text-accent-color-two text-h2-desktop font-serif"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, ease: "easeOut", delay: 0.4 }}
              >
                {data.title}
              </m.p>
            </div>
          )}
          <div
            className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 ${lgCols} justify-center ${
              cardsCount === 6 ? "desktop:grid-rows-2" : ""
            }`}
          >
            {data.card.map((card, idx) => (
              <Card key={card.id} {...card.item} boxHeight={boxHeightClass} />
            ))}
          </div>
        </div>
        </section>
      </div>
    </LazyMotion>
  );
}
